import { render, staticRenderFns } from "./ModalHost.vue?vue&type=template&id=1b4c316e&scoped=true"
import script from "./ModalHost.vue?vue&type=script&lang=js"
export * from "./ModalHost.vue?vue&type=script&lang=js"
import style0 from "./ModalHost.vue?vue&type=style&index=0&id=1b4c316e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4c316e",
  null
  
)

export default component.exports